import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";

import authReducer from "./slice/authSlice";
import authAPI from "./services/authAPI";
import dummyAPI from "./services/dummyAPI";
import usersAPI from "./services/usersAPI";
import reportTemplateAPI from "./services/reportTemplateAPI";
import reportTypeAPI from "./services/reportTypeAPI";
import basisTypeAPI from "./services/basisTypeAPI";
import masterFieldCategoryAPI from "./services/masterFieldCategoryAPI";
import liabilityTypesAPI from "./services/liabilityTypesAPI";
import xmlReportAPI from "./services/xmlReportAPI";
import masterValuationFieldsAPI from "./services/MasterValuationFieldsAPI";

import wordDocumentAPI from "./services/wordDocumentAPI";
import xsdTemplateAPI from "./services/xsdTemplateAPI";
import clientAPI from "./services/ClientAPI";
import clientPlanAPI from "./services/clientPlanAPI";
import clientValuationAPI from "./services/clientValuationAPI";
import fileUploadApi from "./services/uploadCSVAPI";
export const store = configureStore({
    reducer: {
        auth: authReducer,
        [authAPI.reducerPath]: authAPI.reducer,
        [dummyAPI.reducerPath]: dummyAPI.reducer,
        [usersAPI.reducerPath]: usersAPI.reducer,
        [reportTemplateAPI.reducerPath]: reportTemplateAPI.reducer,
        [basisTypeAPI.reducerPath]: basisTypeAPI.reducer,
        [masterFieldCategoryAPI.reducerPath]: masterFieldCategoryAPI.reducer,
        [reportTypeAPI.reducerPath]: reportTypeAPI.reducer,
        [wordDocumentAPI.reducerPath]: wordDocumentAPI.reducer,
        [liabilityTypesAPI.reducerPath]: liabilityTypesAPI.reducer,
        [wordDocumentAPI.reducerPath]: wordDocumentAPI.reducer,
        [xsdTemplateAPI.reducerPath]: xsdTemplateAPI.reducer,
        [xmlReportAPI.reducerPath]: xmlReportAPI.reducer,
        [masterValuationFieldsAPI.reducerPath]: masterValuationFieldsAPI.reducer,
        [clientAPI.reducerPath]: clientAPI.reducer,
        [clientPlanAPI.reducerPath]: clientPlanAPI.reducer,
        [clientValuationAPI.reducerPath]: clientValuationAPI.reducer,
        [fileUploadApi.reducerPath]: fileUploadApi.reducer
    },

    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
        authAPI.middleware,
        dummyAPI.middleware,
        usersAPI.middleware,
        basisTypeAPI.middleware,
        wordDocumentAPI.middleware,
        masterFieldCategoryAPI.middleware,
        reportTypeAPI.middleware,
        reportTemplateAPI.middleware,
        liabilityTypesAPI.middleware,
        xsdTemplateAPI.middleware,
        xmlReportAPI.middleware,
        masterValuationFieldsAPI.middleware,
        clientAPI.middleware,
        clientPlanAPI.middleware,
        clientValuationAPI.middleware,
        fileUploadApi.middleware
    )

})
setupListeners(store.dispatch)